export default __webpack_public_path__ + "static/media/icon-cross.6ee81d30.svg";